(()=>{
  const getSidebar=()=>document.querySelector('.facest-filters-section .m-sidebar');
  const getLabels=()=>{
    const lang=(document.documentElement.lang||'en').toLowerCase();
    if(lang.startsWith('cs'))return {more:'Zobrazit další filtry',less:'Skrýt další filtry',upTo:'Do',over:'Nad'};
    if(lang.startsWith('de'))return {more:'Weitere Filter anzeigen',less:'Weitere Filter ausblenden',upTo:'Bis',over:'Ab'};
    return {more:'Show more filters',less:'Show fewer filters',upTo:'Up to',over:'Over'};
  };
  const formatAmount=(amount,symbol)=>`${new Intl.NumberFormat(document.documentElement.lang||'cs-CZ',{maximumFractionDigits:0}).format(amount)} ${symbol}`.trim();
  const initFilterEnhancements=()=>{
    const labels=getLabels();
    document.querySelectorAll('.m-collection-filters-form').forEach(wrapper=>{
      const form=wrapper.querySelector('form');
      if(form&&form.scrollHeight>1120&&!wrapper.querySelector('.lx-filter-toggle')){
        form.classList.add('lx-filter-truncated');
        const button=document.createElement('button');
        button.type='button';
        button.className='lx-filter-toggle';
        button.textContent=labels.more;
        button.setAttribute('aria-expanded','false');
        button.addEventListener('click',()=>{
          const expanded=form.classList.toggle('lx-filter-expanded');
          form.classList.toggle('lx-filter-truncated',!expanded);
          button.textContent=expanded?labels.less:labels.more;
          button.setAttribute('aria-expanded',expanded?'true':'false');
        });
        form.after(button);
      }
      const price=wrapper.querySelector('[data-luminex-filter="price"] price-range');
      if(!price||price.querySelector('.lx-price-presets'))return;
      const max=Math.floor(Number(price.dataset.priceMax||0));
      if(!max)return;
      const symbol=price.querySelector('.m-facets-price--field-currency')?.textContent.trim()||'';
      const isLowValueCurrency=max<=3000;
      const points=isLowValueCurrency?[200,400,800,1600]:[5000,10000,20000,40000];
      const ranges=[
        {min:null,max:points[0]},
        {min:points[0],max:points[1]},
        {min:points[1],max:points[2]},
        {min:points[2],max:points[3]},
        {min:points[3],max:null}
      ].filter(range=>(range.min||0)<max);
      const minName=price.querySelector('[data-type="min-input"]')?.name;
      const maxName=price.querySelector('[data-type="max-input"]')?.name;
      if(!minName||!maxName)return;
      const presets=document.createElement('div');
      presets.className='lx-price-presets';
      ranges.forEach(range=>{
        const button=document.createElement('button');
        button.type='button';
        button.className='lx-price-preset';
        button.dataset.lxPriceMin=range.min??'';
        button.dataset.lxPriceMax=range.max??'';
        if(range.min===null)button.textContent=`${labels.upTo} ${formatAmount(range.max,symbol)}`;
        else if(range.max===null)button.textContent=`${labels.over} ${formatAmount(range.min,symbol)}`;
        else button.textContent=`${formatAmount(range.min,symbol)}–${formatAmount(range.max,symbol)}`;
        button.addEventListener('click',()=>{
          const url=new URL(location.href);
          url.searchParams.delete(minName);
          url.searchParams.delete(maxName);
          if(range.min!==null)url.searchParams.set(minName,String(range.min));
          if(range.max!==null&&range.max<max)url.searchParams.set(maxName,String(range.max));
          url.searchParams.delete('page');
          url.hash='CollectionProductGrid';
          location.href=url.toString();
        });
        presets.append(button);
      });
      price.querySelector('.m-facets-price--input')?.before(presets);
    });
  };
  const setPanelOpen=open=>{
    const sidebar=getSidebar();
    if(!sidebar)return;
    const content=sidebar.querySelector('.m-sidebar--content');
    const section=sidebar.closest('.facest-filters-section');
    if(open){
      sidebar.style.display='block';
      requestAnimationFrame(()=>{
        sidebar.style.setProperty('--m-bg-opacity','0.5');
        content?.style.setProperty('--m-translate-x','0');
      });
      section?.classList.add('sidebar-open');
      document.documentElement.style.overflow='hidden';
    }else{
      section?.classList.remove('sidebar-open');
      content?.style.setProperty('--m-translate-x','-100%');
      sidebar.style.removeProperty('--m-bg-opacity');
      document.documentElement.style.removeProperty('overflow');
      setTimeout(()=>sidebar.style.removeProperty('display'),300);
    }
    document.querySelectorAll('.m-sidebar--open').forEach(button=>button.setAttribute('aria-expanded',open?'true':'false'));
  };

  document.addEventListener('input',event=>{
    if(!(event.target instanceof Element)||!event.target.matches('[data-luminex-filter-search]'))return;
    const query=event.target.value.trim().toLocaleLowerCase();
    document.querySelectorAll('.m-collection-filters-form [data-luminex-filter]').forEach(group=>{
      const items=[...group.querySelectorAll('.m-facet--item')];
      if(!items.length){
        group.style.display=query?'none':'';
        return;
      }
      let visible=0;
      items.forEach(item=>{
        const show=!query||item.textContent.toLocaleLowerCase().includes(query);
        item.style.display=show?'':'none';
        if(show)visible++;
      });
      group.style.display=visible?'':'none';
    });
  });

  document.addEventListener('click',event=>{
    if(!(event.target instanceof Element))return;
    const quick=event.target.closest('[data-luminex-quick-param]');
    if(quick){
      event.preventDefault();
      const url=new URL(location.href);
      const param=quick.dataset.luminexQuickParam;
      const value=quick.dataset.luminexQuickValue;
      if(url.searchParams.getAll(param).includes(value)){
        url.searchParams.delete(param);
      }else if(param==='sort_by'){
        url.searchParams.set(param,value);
      }else{
        url.searchParams.append(param,value);
      }
      url.searchParams.delete('page');
      url.hash='CollectionProductGrid';
      location.href=url.toString();
      return;
    }

    const openButton=event.target.closest('.m-sidebar--open');
    const closeButton=event.target.closest('.m-sidebar--close');
    const sidebar=getSidebar();
    if(!sidebar||(!openButton&&!closeButton&&event.target!==sidebar))return;
    event.preventDefault();
    event.stopImmediatePropagation();
    setPanelOpen(Boolean(openButton));
  },true);

  document.addEventListener('keydown',event=>{
    if(event.key==='Escape'&&document.querySelector('.facest-filters-section.sidebar-open')){
      setPanelOpen(false);
    }
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initFilterEnhancements);
  else initFilterEnhancements();
})();

const luminexProductGridHashes=['#CollectionProductGrid','#ProductGridContainer'];

function luminexScrollToProductGrid(hash,smooth){
  if(!luminexProductGridHashes.includes(hash))return;
  const target=document.querySelector(hash);
  if(!target)return;
  const behavior=smooth&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches?'smooth':'auto';
  target.scrollIntoView({behavior,block:'start'});
}

function luminexRestoreProductGridPosition(){
  if(!luminexProductGridHashes.includes(window.location.hash))return;
  luminexScrollToProductGrid(window.location.hash,false);
  [300,900,1800].forEach(delay=>{
    window.setTimeout(()=>luminexScrollToProductGrid(window.location.hash,false),delay);
  });
}

document.addEventListener('click',event=>{
  if(!(event.target instanceof Element))return;
  const link=event.target.closest('a[href]');
  if(!link)return;
  const url=new URL(link.href,window.location.href);
  if(url.origin!==window.location.origin||url.pathname!==window.location.pathname)return;
  if(!luminexProductGridHashes.includes(url.hash))return;
  event.preventDefault();
  history.replaceState(null,'',url.hash);
  luminexScrollToProductGrid(url.hash,true);
  window.setTimeout(()=>luminexScrollToProductGrid(url.hash,false),900);
});

if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',luminexRestoreProductGridPosition,{once:true});
}else{
  luminexRestoreProductGridPosition();
}
window.addEventListener('load',luminexRestoreProductGridPosition,{once:true});
